import { CardTypeMatcher } from '../card-type-matcher/CardTypeMatcher';

export function cardTypeValidator(cardTypeMatcher: CardTypeMatcher, messageKey?: string) {
  return async (value: string) => {
    const cardType = await cardTypeMatcher.getCardType(value);
    return !cardType && (messageKey || 'UnsupportedCardType');
  };
}
